import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'

// Temporarily disabled aggressive optimizations
// Service worker optimization completed

// Only register service worker in production with improved error handling
if (import.meta.env.PROD) {
  import('./services/serviceWorker')
    .then(({ registerSW }) => {
      registerSW();
      // Service worker registered successfully
    })
    .catch((error) => {
      console.warn('Service worker registration failed, app will continue normally:', error);
      // App continues to work without service worker
    });
}

createRoot(document.getElementById("root")!).render(<App />);
